module.exports = __webpack_public_path__ + "static/img/Overview_dailycab_2.1a73e81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/videodaily/Overview_dailycab_2.jpg
// module id = gt53
// module chunks = 1